var _path, _circle, _circle2, _rect, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSettingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 10H32.8L30.4 18.4C28.4 19.2 26.6 20.4 25 21.8L16.8 18.8L9.6 31.2L16.4 36.4C16.2 37.6 16 38.8 16 40C16 41.2 16.2 42.4 16.4 43.6L9.6 48.8L16.8 61.2L25 58.2C26.6 59.6 28.4 60.8 30.4 61.6L32.8 70H47.2L49.6 61.6C51.6 60.8 53.4 59.6 55 58.2L63.2 61.2L70.4 48.8L63.6 43.6C63.8 42.4 64 41.2 64 40C64 38.8 63.8 37.6 63.6 36.4L70.4 31.2L63.2 18.8L55 21.8C53.4 20.4 51.6 19.2 49.6 18.4L47.2 10Z",
    fill: "#D1D5DB",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 12,
    fill: "#F3F4F6",
    stroke: "#9CA3AF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 14,
    fill: "#f57c00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 52,
    width: 4,
    height: 14,
    rx: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 70,
    r: 2.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSettingsIcon);
export default __webpack_public_path__ + "static/media/error-settings-icon.6b4bec0ff4e2ba493dab669d413ea018.svg";
export { ForwardRef as ReactComponent };